// extracted by mini-css-extract-plugin
module.exports = {"flexBox":"vxuDz","planpopup":"ngpzq","active":"odNiV","common_blocker_subs":"uRdJc","status_content":"gvkKj","title":"EgPop","desc":"SoWyg","subscription_btn":"aPRdj"};